/**
 * Method turning hex color in an array with the RGB colors
 * @param {STRING} hex color in hex format
 */
const hexToRgb = (hex) => {
  let c;
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('');
    if (c.length == 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]];
    }
    c = '0x' + c.join('');
    const rgbaStr =
      'rgb(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ')';
    return rgbaStr
      .substring(4, rgbaStr.length - 1)
      .replace(/ /g, '')
      .split(',');
  }
  throw new Error('Bad Hex');
};

/**
 * Method returning the best color according to the background color
 * brightness
 * @param {STRING} hex color in hex format
 */
export const fontColorAccordingToBackground = (color) => {
  const rgb = hexToRgb(color);
  const brightness = Math.round(
    (parseInt(rgb[0]) * 299 + parseInt(rgb[1]) * 587 + parseInt(rgb[2]) * 114) /
      1000,
  );
  return brightness > 125 ? 'black' : 'white';
};
